import { useState } from 'react';
import { feedbackService } from '../services/feedbackService';

export const useFeedback = () => {
  const [isLoading, setIsLoading] = useState(false);

  const submitFeedback = async (feedbackData) => {
    try {
      setIsLoading(true);
      const feedback = {
        ...feedbackData,
        createdAt: new Date().toISOString(),
        status: 'PENDING'
      };
      
      await feedbackService.submitFeedback(feedback);
      return true;
    } catch (error) {
      console.error('Erro ao enviar feedback:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    submitFeedback,
    isLoading
  };
};
